module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note10 Aura Red.8566088d.png";